var API_DOMAIN = "https://cmcracker.in/api";

export default API_DOMAIN;
